import {
  CCard,
  CCardBody,
  CCardHeader,
  CForm,
  CFormInput,
  CFormSelect,
  CFormTextarea,
  CRow,
  CCol,
  CButton,
} from "@coreui/react";
import React, { useState } from "react";
import authInstance from "src/api/apiConfig";
import { Loader } from "src/services/const";
import { successAlert, errorAlert } from "src/utils/Swal";
import UserIdentication from "./userIdentication";
import GuarantorReferences from "./guarantorReferences";
import Preview from "./preview";
import { addCustomer } from "src/api/allApis";

const CreateForm = () => {
  const SchemaName = sessionStorage.getItem("schemaName");
  const [dealers, setDealers] = useState([]);
  const [loader, setLoader] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    dob: "",
    fatherName: "",
    gender: "",
    martialStatus: "",
    occupation: "",
    empStartDate: "",
    loanAmountRequested: "",
    loanType: "",
    loanTerm: "",
    plot_no: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    landmark: "",
    branchId: "",
  });

  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    switch (name) {
      case "firstName":
        return value.trim().length >= 3
          ? ""
          : "first name must be at least 3 characters";
      case "lastName":
        return value.trim().length >= 3
          ? ""
          : "last name must be at least 3 characters";
      case "email":
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          ? ""
          : "Valid email is required";
      case "phoneNumber":
        return /^[6-9]\d{9}$/.test(value)
          ? ""
          : "Valid 10-digit Indian mobile number required";
      case "loanType":
        return value ? "" : "Loan type is required";
      case "loanAmountRequested":
        return Number(value) >= 1000 ? "" : "Minimum loan amount is ₹10,000";
      case "gender":
        return value ? "" : "Gender is required";
      case "dob":
        if (!value) return "Date of birth is required";
        const dobDate = new Date(value);
        const minAgeDate = new Date();
        minAgeDate.setFullYear(minAgeDate.getFullYear() - 18);
        return dobDate <= minAgeDate ? "" : "Must be at least 18 years old";
      case "fatherName":
        return value.trim().length >= 3
          ? ""
          : "Father's name must be at least 3 characters";
      case "martialStatus":
        return value ? "" : "Marital status is required";
      case "occupation":
        return value ? "" : "Occupation is required";
      case "empStartDate":
        return value ? "" : "Employment start date is required";
      case "loanTerm":
        return value ? "" : "loan term is required";
      case "plot_no":
        return value.trim() ? "" : "Plot/House number is required";
      case "city":
        return value.trim().length >= 2 ? "" : "City name is required";
      case "state":
        return value.trim().length >= 2 ? "" : "State is required";
      case "country":
        return value.trim() ? "" : "Country is required";
      case "pincode":
        return /^\d{6}$/.test(value) ? "" : "6-digit pincode required";
      case "landmark":
        return value.trim().length >= 3
          ? ""
          : "Landmark must be at least 3 characters";
      case "branchId":
        return value ? "" : "Branch selection is required";
      default:
        return "";
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: validateField(name, value) }));
  };

  const validateAll = () => {
    const newErrors = {};
    Object.entries(formData).forEach(([key, val]) => {
      const err = validateField(key, val);
      if (err) newErrors[key] = err;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateAll()) {
      errorAlert("Validation Error", "Please fix the highlighted fields.");
      return;
    }

    const address = {
      area: formData.plot_no,
      city: formData.city,
      state: formData.state,
      pincode: formData.pincode,
      country: formData.country,
      district: formData.landmark,
    };

    const payload = {
      ...formData,
      address: JSON.stringify(address),
    };

    const response = await addCustomer(payload);
    if (response?.status !== 201) {
      errorAlert("Error", response?.data?.message);
      return;
    }
    successAlert("Success", "Loan application submitted!");
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      loanType: "",
      dob: "",
      gender: "",
      martialStatus: "",
      loanAmountRequested: "",
      fatherName: "",
      loanTerm: "",
      occupation: "",
      empStartDate: "",
      plot_no: "",
      city: "",
      state: "",
      pincode: "",
      country: "",
      landmark: "",
    });
    setErrors({});
  };

  const fetchAllDealers = async () => {
    try {
      const obj = {
        schemaName: SchemaName,
      };

      const response = await authInstance.post("/getAllDealers", obj);
      if (response?.status === 201) {
        setDealers(response?.data?.data);
      }
    } catch (error) {
      console.error(error, "error");
    }
  };

  React.useEffect(() => {
    fetchAllDealers();
  }, []);

  const handleReset = () => {
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      dob: "",
      fatherName: "",
      gender: "",
      martialStatus: "",
      occupation: "",
      empStartDate: "",
      loanAmountRequested: "",
      loanType: "",
      loanTerm: "",
      plot_no: "",
      city: "",
      state: "",
      pincode: "",
      country: "",
      landmark: "",
      branchId: "",
    });
    setErrors({});
  };

  const tabs = [
    "Personal Information",
    "User Identification, Bank and Income Details",
    "Guarantor and References",
    "Preview",
  ];

  const data = {
    firstName: "Rahul Sharma",
    lastName: "Rahul Sharma",
    email: "rahul.sharma@example.com",
    phoneNumber: "9876543210",
    dob: "1990-05-15",
    fatherName: "Ramesh Sharma",
    gender: "Male",
    martialStatus: "Married",
    occupation: "Software Engineer",
    empStartDate: "2015-07-01",
    loanType: "Home Loan",
    loanAmountRequested: "2500000",
    loanTerm: "120",
    branchId: "Mumbai Main Branch",
    plot_no: "B-204",
    city: "Mumbai",
    state: "Maharashtra",
    pincode: "400001",
    country: "India",
    landmark: "Near Shivaji Park",
    bankName: "State Bank of India",
    branchName: "Dadar Branch",
    accountNumber: "123456789012",
    ifsc: "SBIN0001234",
    creditScore: "780",
    income: "150000",
    monthlyExpenses: "75000",
    aadharNumber: "123412341234",
    panNumber: "ABCDE1234F",
    GuarantorName: "Amit Patel",
    fathersName: "Sunil Patel",
    mobileNumber: "9876543211",
    pan: "BCDEF2345G",
    aadhar: "234523452345",
    address: "202, Green Heights, Andheri East, Mumbai",
    GuarantorName1: "Neha Gupta",
    fathersName1: "Rajesh Gupta",
    mobileNumber1: "9876543212",
    pan1: "CDEFG3456H",
    aadhar1: "345634563456",
    address1: "304, Silver Tower, Bandra West, Mumbai",
    refName: "Vikram Singh",
    referencePhoneNumber: "9876543213",
    nameProfessional: "Priya Desai",
    phoneNumberProfessional: "9876543214",

    aadharImageUrl: "https://i.imgur.com/Xb7W6Qy.jpg",
    panImageUrl: "https://i.imgur.com/BXb8wX2.jpg",
    passportSizePhoto: "https://i.imgur.com/Xb7W6Qy.jpg",
    bankStatementsImageUrl: "https://i.imgur.com/Xb7W6Qy.jpg",
    paySlipImageUrl: "https://i.imgur.com/BXb8wX2.jpg",
    singnatureImageUrl: "https://i.imgur.com/o0Z8QLE.jpg",
  };

  return (
    <div className="content">
      <CCard className="mb-4">
        <CCardHeader>
          <strong>Apply for a Loan</strong>
        </CCardHeader>
        <CCardBody>
          <div
            style={{
              background:
                "linear-gradient(187deg, #f2f2f2 0%, #dcdcdc 50%, #c0c0c0 100%)",
              padding: "10px 20px",
              marginBottom: "10px",
              borderRadius: "20px",

              marginBottom: "20px",
            }}
            className="d-flex justify-content-between flex-wrap gap-2"
          >
            {tabs?.map((tab, index) => (
              <div
                key={index}
                onClick={() => setActiveTab(index)}
                style={{
                  padding: "6px 15px",
                  background:
                    activeTab === index
                      ? "linear-gradient(181deg, #000208, #333)"
                      : "",
                  borderRadius: "5px",
                  color: activeTab === index ? "#fff" : "#000",
                  fontWeight: activeTab === index ? "500" : "300",
                  cursor: "pointer",
                  fontSize: "16px",
                  transition: "all 0.2s ease-in-out",
                }}
              >
                {tab}
              </div>
            ))}
          </div>
          {activeTab === 0 && (
            <div>
              <CForm onSubmit={handleSubmit}>
                <CRow className="mb-3">
                  <div className="d-flex justify-content-center pt-5 ">
                    {activeTab === 0 && (
                      <div
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "600",
                        }}
                      >
                        Enter Details: Personal Information
                      </div>
                    )}
                  </div>
                </CRow>
                {/* Row 1 */}
                <CRow className="mb-3">
                  <CCol md={6}>
                    <CFormInput
                      type="text"
                      name="firstName"
                      label="First Name"
                      value={formData.firstName}
                      onChange={handleChange}
                      invalid={!!errors.firstName}
                      feedback={errors.firstName}
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormInput
                      type="text"
                      name="lastName"
                      label="Last Name"
                      value={formData.lastName}
                      onChange={handleChange}
                      invalid={!!errors.lastName}
                      feedback={errors.lastName}
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormSelect
                      name="branchId"
                      label="Branch"
                      value={formData.branchId}
                      onChange={handleChange}
                      options={[
                        { label: "-- Select Branch --", value: "" },
                        ...dealers?.map((branch) => ({
                          label: branch.branchName,
                          value: branch.id,
                        })),
                      ]}
                      // style={{
                      //   backgroundColor: "#fff",
                      //   color: "#000",
                      // }}
                      invalid={!!errors.branchId}
                      feedback={errors.branchId}
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormInput
                      type="email"
                      name="email"
                      label="Email"
                      value={formData.email}
                      onChange={handleChange}
                      invalid={!!errors.email}
                      feedback={errors.email}
                    />
                  </CCol>
                </CRow>

                {/* Row 2 */}
                <CRow className="mb-3">
                  <CCol md={6}>
                    <CFormInput
                      type="number"
                      name="phoneNumber"
                      label="Phone Number"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      invalid={!!errors.phoneNumber}
                      feedback={errors.phoneNumber}
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormInput
                      type="date"
                      name="dob"
                      label="Date of Birth"
                      value={formData.dob}
                      onChange={handleChange}
                      invalid={!!errors.dob}
                      feedback={errors.dob}
                    />
                  </CCol>
                </CRow>

                {/* Row 3 */}
                <CRow className="mb-3">
                  <CCol md={6}>
                    <CFormInput
                      type="text"
                      name="fatherName"
                      label="Father Name"
                      value={formData.fatherName}
                      onChange={handleChange}
                      invalid={!!errors.fatherName}
                      feedback={errors.fatherName}
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormSelect
                      name="gender"
                      label="Gender"
                      value={formData.gender}
                      onChange={handleChange}
                      options={[
                        { label: "-- Select Gender --", value: "" },
                        { label: "male", value: "Male" },
                        { label: "female", value: "Female" },
                        { label: "others", value: "Others" },
                      ]}
                      invalid={!!errors.gender}
                      feedback={errors.gender}
                    />
                  </CCol>
                </CRow>

                <CRow className="mb-3">
                  <CCol md={6}>
                    <CFormSelect
                      name="martialStatus"
                      label="Martial Status"
                      value={formData.martialStatus}
                      onChange={handleChange}
                      options={[
                        { label: "-- Select Martial Status --", value: "" },
                        { label: "single", value: "Single" },
                        { label: "married", value: "Married" },
                      ]}
                      invalid={!!errors.martialStatus}
                      feedback={errors.martialStatus}
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormSelect
                      name="loanType"
                      label="Loan Type"
                      value={formData.loanType}
                      onChange={handleChange}
                      options={[
                        { label: "-- Select Loan Type --", value: "" },
                        { label: "Personal Loan", value: "personal" },
                        { label: "Home Loan", value: "home" },
                        { label: "Business Loan", value: "business" },
                      ]}
                      invalid={!!errors.loanType}
                      feedback={errors.loanType}
                    />
                  </CCol>
                </CRow>

                <CRow className="mb-3">
                  <CCol md={6}>
                    <CFormSelect
                      name="occupation"
                      label="occupation/job"
                      value={formData.occupation}
                      onChange={handleChange}
                      options={[
                        {
                          label: "-- Select Occupation/job Status --",
                          value: "",
                        },
                        { label: "occupation", value: "Occupation" },
                        { label: "job", value: "Job" },
                      ]}
                      invalid={!!errors.occupation}
                      feedback={errors.occupation}
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormInput
                      type="date"
                      name="empStartDate"
                      label="Employment Start Date"
                      value={formData.empStartDate}
                      onChange={handleChange}
                      invalid={!!errors.empStartDate}
                      feedback={errors.empStartDate}
                    />
                  </CCol>
                </CRow>

                <CRow className="mb-3">
                  <CCol md={6}>
                    <CFormInput
                      type="number"
                      name="loanAmountRequested"
                      label="Loan Amount Requested"
                      value={formData.loanAmountRequested}
                      onChange={handleChange}
                      invalid={!!errors.loanAmountRequested}
                      feedback={errors.loanAmountRequested}
                    />
                  </CCol>
                  <CCol md={6}>
                    <CFormInput
                      type="number"
                      name="loanTerm"
                      label="loanTerm[in months]"
                      value={formData.loanTerm}
                      onChange={handleChange}
                      invalid={!!errors.loanTerm}
                      feedback={errors.loanTerm}
                    />
                  </CCol>
                </CRow>

                {/* Address */}
                <CRow className="mb-3">
                  <CCol>
                    <CFormInput
                      type="number"
                      name="plot_no"
                      label="Plot Number / House Number"
                      value={formData.plot_no}
                      onChange={handleChange}
                      invalid={!!errors.plot_no}
                      feedback={errors.plot_no}
                    />
                  </CCol>
                  <CCol>
                    <CFormInput
                      type="text"
                      name="city"
                      label="City"
                      value={formData.city}
                      onChange={handleChange}
                      invalid={!!errors.city}
                      feedback={errors.city}
                    />
                  </CCol>
                </CRow>
                <CRow className="mb-3">
                  <CCol>
                    <CFormInput
                      type="text"
                      name="state"
                      label="State"
                      value={formData.state}
                      onChange={handleChange}
                      invalid={!!errors.state}
                      feedback={errors.state}
                    />
                  </CCol>
                  <CCol>
                    <CFormInput
                      type="text"
                      name="country"
                      label="Country"
                      value={formData.country}
                      onChange={handleChange}
                      invalid={!!errors.country}
                      feedback={errors.country}
                    />
                  </CCol>
                </CRow>
                <CRow className="mb-3">
                  <CCol>
                    <CFormInput
                      type="number"
                      name="pincode"
                      label="Pincode"
                      value={formData.pincode}
                      onChange={handleChange}
                      invalid={!!errors.pincode}
                      feedback={errors.pincode}
                    />
                  </CCol>
                  <CCol>
                    <CFormInput
                      type="text"
                      name="landmark"
                      label="Landmark"
                      value={formData.landmark}
                      onChange={handleChange}
                      invalid={!!errors.landmark}
                      feedback={errors.landmark}
                    />
                  </CCol>
                </CRow>
                <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                  <CButton
                    // type="reset"
                    onClick={handleReset}
                    style={{
                      background: "linear-gradient(181deg, #000208, #333)",
                      padding: "10px 20px",
                    }}
                    color="primary"
                  >
                    Refresh
                  </CButton>

                  {loader ? (
                    <Loader />
                  ) : (
                    <CButton
                      style={{
                        background: "linear-gradient(181deg, #000208, #333)",
                        padding: "10px 20px",
                      }}
                      type="submit"
                      color="primary"
                    >
                      Submit
                    </CButton>
                  )}
                </div>
              </CForm>
            </div>
          )}
          {activeTab === 1 && <UserIdentication />}
          {activeTab === 2 && <GuarantorReferences />}
          {activeTab === 3 && <Preview data={data} />}
        </CCardBody>
      </CCard>
    </div>
  );
};

export default CreateForm;
